import { buildProps } from '../../../../utils/vue/props/runtime.mjs';

const paginationPagerProps = buildProps({
  currentPage: {
    type: Number,
    default: 1
  },
  pageCount: {
    type: Number,
    required: true
  },
  pagerCount: {
    type: Number,
    default: 7
  },
  disabled: Boolean
});

export { paginationPagerProps };
//# sourceMappingURL=pager.mjs.map
